import { Dispatcher } from 'flux';

const ReferralsDispatcher = Object.assign(new Dispatcher(), {
  NAME: 'REFERRALS_DISPATCHER',

  CLAIM_REFERRAL_CODE: 'CLAIM_REFERRAL_CODE',

  handleReferralsAction(action: any) {
    this.dispatch({
      source: ReferralsDispatcher.NAME,
      action,
    });
  },
});
export default ReferralsDispatcher;
